export default {"src":"/_next/static/media/pccp.41766107.svg","height":10,"width":31,"blurWidth":0,"blurHeight":0};